import { FiArrowRight } from "react-icons/fi";
import moment from "moment";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function StepperAmlCheck({ timeline }) {
  return (
    <nav aria-label="Progress">
      <ol role="list" className="overflow-hidden mt-4">
        {timeline && timeline.length > 0 ? (
          timeline.map((step, stepIdx) => (
            <li
              key={stepIdx}
              className={classNames(
                stepIdx !== timeline.length - 1 ? "pb-8" : "",
                "relative"
              )}
            >
              <>
                {stepIdx !== timeline.length - 1 || stepIdx === 0 ? (
                  <div
                    aria-hidden="true"
                    className="absolute left-3 top-4 -ml-px mt-0.5 h-full w-[1px] bg-[#6F6F6F]"
                  />
                ) : null}
                <span className="group relative flex items-start">
                  <span aria-hidden="true" className="flex h-9 items-center">
                    <span className="relative z-10 flex h-6 w-6 items-center justify-center rounded-full bg-white">
                      <span className="bg-[#6F6F6F] h-2 w-2 rounded-full" />
                    </span>
                  </span>
                  <span className="ml-4 flex min-w-0 flex-col gap-2">
                    <div className="flex flex-row justify-start items-center gap-4">
                      <span
                        className={`text-xs font-medium px-2 py-0.5 rounded text-white ${
                          step.from_status === "Low Risk" ||
                          step.from_status === "low_risk"
                            ? "bg-[#218838]"
                            : step.from_status === "Medium Risk" ||
                              step.from_status === "medium_risk"
                            ? "bg-[#d4af37]"
                            : step.from_status === "High Risk" ||
                              step.from_status === "high_risk"
                            ? "bg-[#e65100]"
                            : "bg-[#C82333]"
                        }`}
                      >
                        {step.from_status === "low_risk"
                          ? "Low Risk"
                          : step.from_status === "medium_risk"
                          ? "Medium Risk"
                          : step.from_status === "high_risk"
                          ? "High Risk"
                          : "Blocked"}
                      </span>
                      <FiArrowRight size={"15"} />
                      <span
                        className={`text-xs px-2 py-0.5 rounded font-medium text-white ${
                          step.to_status === "Low Risk" ||
                          step.to_status === "low_risk"
                            ? "bg-[#218838]"
                            : step.to_status === "Medium Risk" ||
                              step.to_status === "medium_risk"
                            ? "bg-[#D4AF37]"
                            : step.to_status === "High Risk" ||
                              step.to_status === "high_risk"
                            ? "bg-[#E65100]"
                            : "bg-[#C82333]"
                        }`}
                      >
                        {step.to_status === "low_risk"
                          ? "Low Risk"
                          : step.to_status === "medium_risk"
                          ? "Medium Risk"
                          : step.to_status === "high_risk"
                          ? "High Risk"
                          : step.to_status}
                      </span>
                    </div>
                    <span className="text-xs text-[#262626]">
                      {moment(step && step?.change_date).format("l")}{" "}
                      {moment(step && step?.change_date).format("LT")}
                    </span>
                    <span className="text-xs text-[#6F6F6F] border border-solid border-[#E0E0E0] p-2 rounded">
                      {step.comment}
                    </span>
                  </span>
                </span>
              </>
            </li>
          ))
        ) : (
          <li className="border border-solid border-[#E0E0E0] p-4 rounded-lg">
            No Timline available
          </li>
        )}
      </ol>
    </nav>
  );
}
